export const INVALID_DISCOUNT_CODE_ERROR = "This discount code cannot be used";
export const INVALID_EMAIL_ADDRESS = "Please enter a valid email address.";

const errorMessages = {
  INVALID_DISCOUNT_CODE_ERROR,
  INVALID_EMAIL_ADDRESS,
};

export default errorMessages;
